module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASBAMAAABGPIgdAAAAKlBMVEUAAAD/aZb/aY/6aZH7aY/8aZD9aY/9aZD7aY/8aY/9aY/8aY/8aY/8aY/UpQfFAAAADXRSTlMAESIzRFVmd4i7zN3u50wUOAAAAHdJREFUCB09wbEJwkAAQNFPSGFpK65gkRFshQgu4ADpsoDgCg5gncrK2hGuEkmE/F3Mxbu8B4fQQTN2wEp9btQbHNXxpQ5wNxkhmFW42PMwW3Mx+cLW5A2lSQucnQ1MymB0Jaqd9MzKoLb81dqTFMET2e7DoqiIfjNMZqDGmZtrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/heart-hover.png
// module id = 675
// module chunks = 0